// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"696":"8594b946","703":"d4adac93","787":"ae2fb8aa"}[chunkId] + ".chunk.js";
};